import React from 'react';
import { useTranslation } from 'react-i18next';
import { getEquipmentData } from '../../data/equipmentListData';
import './equipment.scss';


function EquipmentTable() {
  const { t, i18n } = useTranslation();
  const equipmentListData = getEquipmentData(i18n.language === 'en' ? 'en' : 'cs');

  return (
    <div>
      {equipmentListData.map((category, index) => (
        <div key={index}>
          <h2>{category.category}</h2>
          <table>
            <thead>
              <tr>
                <th className='strong'><h4>{t('equipment.manufacturer')}</h4></th>
                <th ><h4>{t('equipment.type')}</h4></th>
                <th><h4>{t('equipment.description')}</h4></th>
              </tr>
            </thead>
            <tbody>
              {category.items.map((item, index) => (
                <tr key={index}>
                  <td>{item.vyrobce}</td>
                  <td>{item.typ}</td>
                  <td>{item.popis}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

export default EquipmentTable;